import { createInitialState } from "../utility/utility";

export const APPROVALS = createInitialState();
